import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout.vue'
import HardWare from '../views/HardWare.vue';
import SoftWare from "../views/SoftWare.vue"
import Solutions from "../views/Solutions.vue"
import CaseList from "../views/CaseList.vue"
import Detial from "../views/Detial.vue"
import NewsList from "../views/NewsList.vue";
import NewsDetial from "../views/NewsDetial.vue"
import Chart from "../views/Chart.vue"
import WareMoreHard from "../views/WareMoreHard.vue"
import WareMoreSoft from "../views/WareMoreSoft.vue"
import getPageTitle from "@/utils/getPageTitle";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    children:[
      {
          path: '/',
          name: 'index',
          meta:{
            title:'首页'
          },
          // redirect:'/shopping',//重定向==================
          component: () => import(/* webpackChunkName: "about" */ '../views/Index.vue')
      },
      {
        path: '/hardware',
        name: 'hardware',
        meta:{
          title:'智能硬件'
        },
        component: HardWare,
      },
      {
        path: '/software',
        name: 'software',
        meta:{
          title:'智能软件'
        },
        component: SoftWare,
      },
      {
        path: '/solutions',
        name: 'solutions',
        meta:{
          title:'解决方案'
        },
        component: Solutions,
      },
      {
        path: '/caselist',
        name: 'caselist',
        meta:{
          title:'典型案例'
        },
        component: CaseList,
      },
      {
        path: '/detial/:id',
        meta:{
          title:'典型案例'
        },
        name: 'detial',
        component: Detial,
      },
      {

        path: '/newslist',
        name: 'newslist',
        meta:{
          title:'新闻资讯'
        },
        component: NewsList,
      },
      {
        path: '/newsdetial/:id',
        name: 'newsdetial',
        meta:{
          title:'新闻资讯'
        },
        component: NewsDetial,
      },
      {
        path: '/waremorehard/:id',
        name: 'waremorehard',
        meta:{
          title:'智能硬件'
        },
        component: WareMoreHard,
      },
      {
        path: '/waremoresoft/:id',
        name: 'waremoresoft',
        meta:{
          title:'智能软件'
        },
        component: WareMoreSoft,
      },
      {
        path: '/about',
        meta:{
          title:'关于我们'
        },
        name: 'about',
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      },
      {
        path: '/enterprise/:id',
        name: 'enterprise',
        meta:{
          title:'企业资质'
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/Enterprise.vue')
      },
      {
        path: '/contact/:id',
        meta:{
          title:'联系我们'
        },
        name: 'contact',
        component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue')
      },
      {
        path: '/qualification/:id',
        meta:{
          title:'资质查询'
        },
        name: 'qualification',
        component: () => import('../views/Qualification.vue')
      },
      {
        path: '/zisonaiApp',
        meta:{
          title:'zisonaiApp'
        },
        name: 'zisonaiApp',
        component: () => import(/* webpackChunkName: "about" */ '../views/ZisonaiApp.vue'),
      },
      {
        path: '/shopping',
        meta:{
          title:'商城'
        },
        name: 'shopping',
        component: () => import(/* webpackChunkName: "about" */ '../views/Shopping.vue'),
      },
      {
        path: '/GoodsDetial/:id',
        meta:{
          title:'商品详情'
        },
        name: 'goodsDetial',
        component: () => import(/* webpackChunkName: "about" */ '../views/GoodsDetial.vue')
      },
      {
        path: '/SuccessCart',
        meta:{
          title:'加入购物车',
          isLogin:true
        },
        name: 'successCart',
        component: () => import(/* webpackChunkName: "about" */ '../views/SuccessCart.vue')
      },
      {
        path: '/MyCart',
        meta:{
          title:'我的购物车',
          isLogin:true
        },
        name: 'myCart',
        component: () => import(/* webpackChunkName: "about" */ '../views/MyCart.vue')
      },
      {
        path: '/settlein',
        meta:{
          title:'商家入驻'
        },
        name: 'settlein',
        component: () => import(/* webpackChunkName: "about" */ '../views/SettleIn.vue'),
        children:[
          {
            path: 'settleinpro',
            meta:{
              title:'入驻流程'
            },
            name: 'settleinpro',
            component: () => import(/* webpackChunkName: "about" */ '../views/SettleInPro.vue'),
          },
          {
            path: 'settleinagree',
            meta:{
              title:'入驻协议'
            },
            name: 'settleinagree',
            component: () => import(/* webpackChunkName: "about" */ '../views/Agreement.vue'),
          },
          {
            path: 'settleininfo',
            meta:{
              title:'入驻信息'
            },
            name: 'settleininfo',
            component: () => import(/* webpackChunkName: "about" */ '../views/SettleInInfo.vue'),
          },
        ]
      },
      {
        path: '/paid',
        meta:{
          title:'有偿资讯'
        },
        name: 'paid',
        component: () => import(/* webpackChunkName: "about" */ '../views/Paid.vue')
      },
      {
        path: '/shopstreet',
        meta:{
          title:'店铺街'
        },
        name: 'shopstreet',
        component: () => import(/* webpackChunkName: "about" */ '../views/ShopStreet.vue'),
        children:[
          {
            path: 'shopstreetpro',
            meta:{
              title:'店铺街'
            },
            name: 'shopstreetpro',
            component: () => import(/* webpackChunkName: "about" */ '../views/ShopStreetPro.vue'),
          },
          {
            path: 'shopstreetinfo',
            meta:{
              title:'店铺详情'
            },
            name: 'shopstreetinfo',
            component: () => import(/* webpackChunkName: "about" */ '../views/ShopStreetInfo.vue'),
          },
        ]
      },
    ]
  },
  {
    path:"/chart",
    component:Chart
  },  
  {
    path: '/Login/:params?',
    meta:{
      title:'登录'
    },
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
   {
    path: '/qualificationPhone/:id',//手机扫码查看资质 打开进入后就是这个列表
    meta:{
      title:'资质查询'
    },
    name: 'qualificationPhone',
    component: () => import('../views/QualificationPhone.vue')
  },
]
//添加以下代码  禁止本页条本页
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,  // 如果使用history模式，必须设置base参数
  scrollBehavior(to, from, savedPosition) {
    // 期望滚动到哪个位置
    return {
      x: 0,
      y: 0
    }
  },
  routes
})
router.beforeEach((to, from, next) => {
  // 路由跳转后，让页面回到顶部
  document.body.scrollTop = 0; 
  document.documentElement.scrollTop = 0; 
  window.pageYOffset = 0; 
  document.title = getPageTitle(to.meta.title);
  // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁!!
  next();
});
export default router
